export function homeForRole(role?: string): string {
  if (role === 'VIEWER') return '/mis-resultados';
  if (role === 'MEDICO') return '/buscar-analisis';
  return '/dashboard';
}
